import React from 'react';
import styled from 'styled-components';

import { Paper, Container } from '@material-ui/core';
import HeaderImage from 'images/header-img.png';
import breakpoints from 'utils/breakpoints';

const HeaderWrapper = styled(({ reverse, ...props }) => <div {...props} />)`
  height: ${(props: { height?: string }) => props.height || '519px'};
  &:before {
    content: '';
    background-color: black;
    background-repeat: no-repeat;
    width: 100vw;
    height: ${(props: { height?: string }) => props.height || '519px'};
    background-image: url(${(props: { image?: string; height?: string }) =>
      props.image || HeaderImage});
    position: absolute;
    z-index: -1000;
    top: 0px;
    left: 0px;
    transform: ${(props) => (props.reverse ? 'scaleX(-1)' : '')};
    background-size: cover;
  }
`;

const StyledContainer = styled(Container)`
  margin-top: -140px;
`;

const OffersAndAdviceWrapper = styled.div`
  height: 308px;
  background-color: #63b7bb;
`;
const WelcomeHeaderWrapper = styled.div`
  > h6 {
    color: #ffffff !important;
  }
`;

const FAQWrapper = styled(Paper)`
  height: 367px;
  border-radius: 8px !important;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.03), 0 0 24px 0 rgba(0, 0, 0, 0.08) !important;
`;

const MyServicesWrapper = styled(Paper)`
  box-shadow: none !important;
  height: 93px;
  @media (max-width: ${breakpoints.xs}) {
    height: auto;
  }
`;
const MyBlocContainer = styled(({ ...props }) => <Paper {...props} />)`
  height: 367px;
  border-radius: 8px !important;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.03), 0 0 24px 0 rgba(0, 0, 0, 0.08) !important;
  @media (max-width: ${breakpoints.xs}) {
    height: auto;
  }
`;

export {
  HeaderWrapper,
  StyledContainer,
  OffersAndAdviceWrapper,
  WelcomeHeaderWrapper,
  FAQWrapper,
  MyServicesWrapper,
  MyBlocContainer,
};
